import { useHistory, useLocation } from 'react-router-dom';

export const useSearchParam = (searchParam: string) => {
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const searchParamValue = query.get(searchParam);

  const clearSearchParam = () => {
    const params = new URLSearchParams(location.search);
    params.delete(searchParam);
    history.replace({
      pathname: location.pathname,
      search: params.toString(),
      hash: location.hash,
    });
  };

  return { searchParamValue, clearSearchParam };
};
